// extracted by mini-css-extract-plugin
module.exports = {"paymentStatusFilter":"Invoices_paymentStatusFilter__1N4W_","statusFilter":"Invoices_statusFilter__2IH7b"};